<template>
<div class="RssList">
    <ul>
        <li v-for="(item, index) in list" :key="index">
            <RssListItem :index="index" :title="item.title" :sub="sub ? item.sub : ''" @select="select(index)"></RssListItem>
        </li>
    </ul>
</div>
</template>
<script>
import RssListItem from './RssListItem.vue';

export default {
  name: 'List',
  components: {
    RssListItem,
  },
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    sub: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    select(index) {
      this.$emit('select', index);
    },
  },
};
</script>
<style lang="sass">
.RssList
  +size(100%, 100%)
  text-align: center
  ul
    +flex(flex-start, center, column)
    +size(100%, 100%)
    flex-wrap: wrap
    box-sizing: border-box
</style>
